const defaultProjectsTotal = 25;

export default defaultProjectsTotal;
